// Import CustomSelect
// https://github.com/zoltantothcom/vanilla-js-dropdown
// eslint-disable-next-line import/no-extraneous-dependencies
import CustomSelect from 'vanilla-js-dropdown';

document.querySelectorAll('.select--custom').forEach((element) => {
  // eslint-disable-next-line no-new
  new CustomSelect({
    elem: element,
  });
});

document.querySelectorAll('.js-Dropdown').forEach((item) => {
  item.setAttribute('tabindex', '0');
});

document.querySelectorAll('.js-Dropdown-title').forEach((item) => {
  item.setAttribute('tabindex', '-1');
});

document.querySelectorAll('.js-Dropdown-list').forEach((element) => {
  // eslint-disable-next-line no-new

  const listItems = element.querySelectorAll('li');
  listItems.forEach((item, index) => {
    item.setAttribute('tabindex', '0');
    item.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        item.click();
      } else if (event.key === 'ArrowDown') {
        event.preventDefault();
        const next = item.nextElementSibling;
        if (next) {
          next.focus();
        }
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        const prev = item.previousElementSibling;
        if (prev) {
          prev.focus();
        }
      }
    });
  });
});